module.exports = __webpack_public_path__ + "img/Agregar y Listo animación.a8c3d98f.gif";